import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Toolbar,
  Typography,
  Avatar,
} from "@mui/material";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import { makeStyles, styled } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import vector from "../../assets/images/vector.svg";
import kpiArrow from "../../icons/kpiArrow.svg";
import myFeedback from "../../services/myFeedback.service";
// import PdfIcon from "../../assets/images/iconFile/pdf.svg";
// import JpgIcon from "../../assets/images/iconFile/jpg.svg";
// import PngIcon from "../../assets/images/iconFile/png.svg";
// import NullIcon from "../../assets/images/iconFile/Null-File.svg";
// import JpegIcon from "../../assets/images/iconFile/jpeg.svg";
import { ReactComponent as PdfIcon } from "../../assets/images/iconFile/pdf.svg";
import { ReactComponent as JpgIcon } from "../../assets/images/iconFile/jpg.svg";
import { ReactComponent as PngIcon } from "../../assets/images/iconFile/png.svg";
import { ReactComponent as NullIcon } from "../../assets/images/iconFile/Null-File.svg";
import { ReactComponent as Feedback } from "../../assets/images/myFeedback.svg";
import { ReactComponent as RequestFeedback } from "../../assets/icons/requestFeedback.svg";
import * as Util from "../../services/global.service";
import { ReactComponent as Nodata } from "../../assets/icons/nodata.svg";
import { getFileDetail } from "../../actions/achievement";


import angry from "../../assets/images/angry.png";
import bored from "../../assets/images/bored.png";
import lazy from "../../assets/images/lazy.png";
import worried from "../../assets/images/worried.png";
import disappointed from "../../assets/images/disappointed.png";
import accomplished from "../../assets/images/accomplished.png";
import loved from "../../assets/images/loved.png";
import joyful from "../../assets/images/joyful.png";
import happy from "../../assets/images/happy.png";
import excited from "../../assets/images/excited.png";
const useStyles = makeStyles({

});


const DialogAchievements = (props) => {
  const { open, close, data, type, dataViewFeedback, openRequest } = props
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [feedbackQuestion, setFeedbackQuestion] = React.useState([]);
  useEffect(() => {
    if (open && Util.formatData(dataViewFeedback?.serial, false) !== false && Util.formatData(dataViewFeedback?.type, false) !== false && Util.formatData(dataViewFeedback?.formID, false) !== false) {
      myFeedback.getEvaluateFeedback(dataViewFeedback?.serial, dataViewFeedback?.type, dataViewFeedback?.formID).then((rs) => {
        setFeedbackQuestion(Util.formatData(rs?.data?.feedback, []))
      })
    } else {
      setFeedbackQuestion([])
    }
  }, [open]);

  const handleCloseDialog = () => {
    close(false);
  };

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }))

  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '30px 30px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px", display: "flex", justifyContent: "space-between", alignItems: "center", }} color="#404349">
        {t('evaluation.feedbackForThis')}{dataViewFeedback?.type === "probation" ? t('evaluation.item') : dataViewFeedback?.type === "goal" ? t('evaluation.goal') : t('evaluation.competency')}
        <Button startIcon={<RequestFeedback />} onClick={e => openRequest()} color="primary" variant="contained" sx={{ textTransform: "none", py: "10.25px", mr: "50px", fontSize: "16px", lineHeight: "23.92px", fontWeight: "500" }}>
          {t('feedback.label.requestFeedback')}
        </Button>
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: "10px" }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: "0" }}>
        <Box sx={{ padding: "20px 0 0px" }}>
          <Box pb="30px">
            <Box display="flex">
              <Box width="225px" pr="20px">
                <Typography color="#A3A3A3" fontSize={18} lineHeight="26.91px">{dataViewFeedback?.type === "probation" ? t('evaluation.probationName') : dataViewFeedback?.type === "goal" ? t('evaluation.goalName') : dataViewFeedback?.type === "competency" ? t('evaluation.competencyName') : ""}</Typography>
              </Box>
              <Box width="calc(100% - 225px)">
                <Typography color="#404349" fontSize={18} lineHeight="26.91px" dangerouslySetInnerHTML={{ __html: Util.formatData(dataViewFeedback?.name, "-") }}></Typography>
              </Box>
            </Box>
            {dataViewFeedback?.type !== "probation" ?
              <Box display="flex" py="20px">
                <Box width="225px" pr="20px">
                  <Typography color="#A3A3A3" fontSize={18} lineHeight="26.91px">{dataViewFeedback?.type === "goal" ? t('evaluation.goalDescription') : dataViewFeedback?.type === "competency" ? t('evaluation.competencyDescription') : ""}</Typography>
                </Box>
                <Box width="calc(100% - 225px)">
                  <Typography color="#404349" fontSize={18} lineHeight="26.91px" dangerouslySetInnerHTML={{ __html: Util.formatData(dataViewFeedback?.description, "-")}}></Typography>
                </Box>
              </Box>
              : null
            }
          </Box>
          {Util.formatData(feedbackQuestion, []).length > 0 ?
            feedbackQuestion.map((row, idx) =>
              <Box pb={idx === feedbackQuestion.length - 1 ? "" : "20px"} >
                <Box sx={{ display: "flex", width: "100%" }} >
                  <Avatar
                    src={row?.employee?.photo}
                    sx={{
                      width: 30,
                      height: 30,
                    }}
                  >
                  </Avatar>
                  <Box pl="10px" width="calc(100% - 30px)">
                    <Box display="flex" >
                      <Box pr="20px" width="calc(100% - 100px)">
                        <Typography color="#888F9D" fontWeight="500" fontSize={12} lineHeight="17.94px" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{row?.employee?.fullname} <span style={{ "font-weight": "400" }}>{Util.formatData(row?.employee?.organization) !== false && Util.formatData(row?.employee?.position) !== false ? " (" + row?.employee?.position + ", " + row?.employee?.organization + ")" : Util.formatData(row?.employee?.organization) !== false || Util.formatData(row?.employee?.position) !== false ? " (" + row?.employee?.organization + row?.employee?.position + ")" : ""}</span></Typography>
                      </Box>
                      <Box width="100px">
                        <Typography color="#888F9D" fontWeight="400" fontSize={12} lineHeight="17.94px" sx={{ textAlign: "end" }}>{Util.formatData(row?.date, false) !== false ? Util.dateDayFormatAdmin(row?.date) : ""}</Typography>
                      </Box>
                    </Box>
                    {Util.formatData(row?.emotion, false) !== false ?
                      <Box pt="5px">
                        <BootstrapTooltip title={<span style={{ "font-weight": "400", "font-size": "16px", "line-height": "21px", }}>{row?.emotion === "angry" ? t('feedback.label.angry') : row?.emotion === "bored" ? t('feedback.label.bored') : row?.emotion === "lazy" ? t('feedback.label.lazy') : row?.emotion === "worried" ? t('feedback.label.worried') : row?.emotion === "disappointed" ? t('feedback.label.disappointed') : row?.emotion === "accomplished" ? t('feedback.label.accomplished') : row?.emotion === "loved" ? t('feedback.label.loved') : row?.emotion === "joyful" ? t('feedback.label.joyful') : row?.emotion === "happy" ? t('feedback.label.happy') : row?.emotion === "excited" ? t('feedback.label.excited') : "-"}</span>} placement="top">
                          <img width="60px" height="60px" src={row?.emotion === "angry" ? angry : row?.emotion === "bored" ? bored : row?.emotion === "lazy" ? lazy : row?.emotion === "worried" ? worried : row?.emotion === "disappointed" ? disappointed : row?.emotion === "accomplished" ? accomplished : row?.emotion === "loved" ? loved : row?.emotion === "joyful" ? joyful : row?.emotion === "happy" ? happy : row?.emotion === "excited" ? excited : ""} alt={row?.emotion === "angry" ? angry : row?.emotion === "bored" ? bored : row?.emotion === "lazy" ? lazy : row?.emotion === "worried" ? worried : row?.emotion === "disappointed" ? disappointed : row?.emotion === "accomplished" ? accomplished : row?.emotion === "loved" ? loved : row?.emotion === "joyful" ? joyful : row?.emotion === "happy" ? happy : row?.emotion === "excited" ? excited : ""} />
                        </BootstrapTooltip>
                      </Box>
                      :
                      null
                    }
                    {Util.formatData(row?.comment, false) !== false ?
                      <Box p="10px 15px" mt="5px" backgroundColor="#EFF6F4" borderRadius="0px 20px 20px 20px" sx={{ width: "max-content", maxWidth: " 100%" }}>
                        <Typography color="#404349" fontWeight="400" fontSize={16} lineHeight="23.92px" >{Util.formatData(row?.comment, "-")}</Typography>
                      </Box>
                      :
                      null
                    }

                    {Util.formatData(row?.comment, false) === false && Util.formatData(row?.emotion, false) === false ?
                      <Box p="10px 15px" mt="5px" backgroundColor="#F6F6F6" borderRadius="0px 20px 20px 20px" sx={{ width: "max-content", maxWidth: " 100%" }}>
                        <Typography color="#888F9D" fontWeight="400" fontSize={16} lineHeight="23.92px" >{t('feedback.label.waitingForFeedback')}</Typography>
                      </Box>
                      :
                      null
                    }
                  </Box>
                </Box>
              </Box>
            )
            :
            <Box pt="30px" sx={{ display: "flex", flexDirection: "column", alignItems: "center", }}>
              <Feedback />
              <Typography pt="30px" color="#888F9D" fontWeight="600" fontSize={20} lineHeight="29.9px" textAlign="center" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{dataViewFeedback?.type === "probation" ? t('evaluation.noFeedbackForThisProbation') : dataViewFeedback?.type === "goal" ? t('evaluation.noFeedbackForThisGoal') : dataViewFeedback?.type === "competency" ? t('evaluation.noFeedbackForThiCompetency') : ""},</Typography>
              <Typography color="#888F9D" fontWeight="400" fontSize={16} lineHeight="23.92px" textAlign="center" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t('feedback.label.pleaseClick')} <span style={{ color: "#5DA196", cursor: "pointer", "font-weight": "500", "text-decoration-line": "underline" }} onClick={e => openRequest()} >{t('feedback.label.here')}</span> {t('feedback.label.toRequestFeedback')}</Typography>
            </Box>
          }
        </Box>
      </DialogContent>
    </Dialog >
  );
};
export default DialogAchievements;
